<section class='projeto-componente'>
  <Div class="projeto"></Div>
  <div class="container banner-projetoWrapper">
    <div class="banner-projeto">
      <h3 >Ippo Tecnologia</h3>
      <p > Opção em construção / desenvolvimento</p>
    </div>
  </div>
</section>
